import { render, staticRenderFns } from "./GongGao.vue?vue&type=template&id=56c5ae96&scoped=true&"
import script from "./GongGao.vue?vue&type=script&lang=js&"
export * from "./GongGao.vue?vue&type=script&lang=js&"
import style0 from "./GongGao.vue?vue&type=style&index=0&id=56c5ae96&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c5ae96",
  null
  
)

export default component.exports